import React from 'react';
import { injectIntl } from "react-intl";
import * as paths from '@app/constants/paths';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
// nodejs library that concatenates classes
import classNames from "classnames";
import LinearProgress from '@material-ui/core/LinearProgress';
import CustomHelmet from "@app/components/CustomHelmets/CustomHelmet";
import CustomHeader from "@app/components/Header/CustomHeader";
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Message from '@app/components/Message/Message';
import Card from '@app/components/Card/Card';
import CardBody from '@app/components/Card/CardBody';
import CardHeader from '@app/components/Card/CardHeader';
import CardFooter from '@app/components/Card/CardFooter';
import Button from "@app/components/CustomButtons/Button";
import AboutYourBusinessContainer from './AboutYourBusinessContainer';
import DescribeYourBusinessContainer from './DescribeYourBusinessContainer';
import DescribeYourProjectContainer from './DescribeYourProjectContainer';
import DevelopProjectPlanContainer from './DevelopProjectPlanContainer';
import BusinessInvestmentContainer from './BusinessInvestmentContainer';
import ProjectedOutcomesContainer from './ProjectedOutcomesContainer';
import ProjectElementsContainer from './ProjectElementsContainer';
import ProjectCostsContainer from './ProjectCostsContainer';
import GrantHistoryContainer from './GrantHistoryContainer';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import tovsHelperStyle from '@app/assets/jss/material-kit-pro-react/views/tovsHelperStyle';

function getStepContent(step, props) {
    switch (step) {
        case paths.HELPER_T_O_V_S_ABOUT:
            return (
                <AboutYourBusinessContainer
                    history={props.history}
                    locale={props.locale}
                    previousStep={props.previousStep}
                    setCurrentStep={props.setCurrentStep}
                    nextStep={props.nextStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages} />
            );
        case paths.HELPER_T_O_V_S_DESCRIBE:
            return (
                <DescribeYourBusinessContainer
                    history={props.history}
                    locale={props.locale}
                    setCurrentStep={props.setCurrentStep}
                    nextStep={props.nextStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages} />                
            );
        case paths.HELPER_T_O_V_S_PROJECT:
            return (               
                <DescribeYourProjectContainer
                    history={props.history}
                    locale={props.locale}
                    setCurrentStep={props.setCurrentStep}
                    nextStep={props.nextStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages} />
            );
        case paths.HELPER_T_O_V_S_PLAN:
            return (
                <DevelopProjectPlanContainer
                    history={props.history}
                    locale={props.locale}
                    setCurrentStep={props.setCurrentStep}
                    nextStep={props.nextStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages}/>
            );
        case paths.HELPER_T_O_V_S_INVEST:
            return (
                <BusinessInvestmentContainer
                    history={props.history}
                    locale={props.locale}
                    setCurrentStep={props.setCurrentStep}
                    nextStep={props.nextStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages} />
            )
        case paths.HELPER_T_O_V_S_OUTCOMES:
            return (
                <ProjectedOutcomesContainer
                    history={props.history}
                    locale={props.locale}
                    setCurrentStep={props.setCurrentStep}
                    nextStep={props.nextStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages} />
            )
        case paths.HELPER_T_O_V_S_ELEMENTS:
            return (
                <ProjectElementsContainer
                    history={props.history}
                    locale={props.locale}
                    setCurrentStep={props.setCurrentStep}
                    nextStep={props.nextStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages} />
            )
        case paths.HELPER_T_O_V_S_QUOTE:
            return (
                <ProjectElementsContainer
                    history={props.history}
                    locale={props.locale}
                    setCurrentStep={props.setCurrentStep}
                    nextStep={props.nextStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages}
                    quotePage={true} />
            )
        case paths.HELPER_T_O_V_S_COSTS:
            return (
                <ProjectCostsContainer
                    history={props.history}
                    locale={props.locale}
                    setCurrentStep={props.setCurrentStep}
                    nextStep={props.nextStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages} />
            )
        case paths.HELPER_T_O_V_S_GRANT:
            return (
                <GrantHistoryContainer
                    history={props.history}
                    locale={props.locale}
                    businessCardData={props.businessCardData}
                    continuePath={props.continuePath}
                    setCurrentStep={props.setCurrentStep}
                    cancel={props.cancel}
                    setIsLoading={props.setIsLoading}
                    setSuccessMessage={props.setSuccessMessage}
                    setErrorMessage={props.setErrorMessage}
                    resetMessages={props.resetMessages} />
            )
        default:
            return '';
    }
}

const muiTheme = createMuiTheme({
    typography: {
      useNextVariants: true,
    },
    overrides: {
        MuiStepper: {
            root: {
                padding: "27px 0px"
            }            
        },
        MuiStepIcon: {
            root: {
                color: "#999",
                '&$active': {
                    color: '#26c6da',
                },
                '&$completed': {
                    color: '#26c6da',
                },
            },
        },
    }
});

const ProfileWizardView = (props) => {
    const { classes } = props;    
    // Meta tags
    const appName = props.intl.formatMessage({ id: "app.name" });
    const headerColor = props.intl.formatMessage({ id: "calc.o.p.s.headerColor"});
    // OG meta tags [static]
    const ogType = props.intl.formatMessage({ id: "og.type" });
    const ogLocale = props.intl.formatMessage({ id: "og.locale" });
    const ogLocaleAlt1 = props.intl.formatMessage({ id: "og.localeAlt1" });
    const ogLocaleAlt2 = props.intl.formatMessage({ id: "og.localeAlt2" });
    const ogSiteName = props.intl.formatMessage({ id: "og.site.name" });
    // OG meta tags [dynamic]
    const ogTitle = props.intl.formatMessage({ id: "trading.online.voucher.scheme" }) + " - " + props.intl.formatMessage({ id: "application.form.helper" });
    const ogDescription = props.intl.formatMessage({ id: "calc.o.p.s.og.description" });
    const ogImage = props.intl.formatMessage({ id: "calc.o.p.s.og.image" });
    const ogImageAlt = props.intl.formatMessage({ id: "calc.o.p.s.og.image.alt" });
    const ogImageType = props.intl.formatMessage({ id: "calc.o.p.s.og.image.type" });
    const ogImageWidth = Number(props.intl.formatMessage({ id: "calc.o.p.s.og.image.width" }));
    const ogImageHeight = Number(props.intl.formatMessage({ id: "calc.o.p.s.og.image.height" }));
    // Twitter meta tags
    const twitterCardType = props.intl.formatMessage({ id: "meta.twitterCardType" });
    const twitterCreator = props.intl.formatMessage({ id: "meta.twitterCreator" });
    const twitterTitle = props.intl.formatMessage({ id: "calc.o.p.s.meta.twitterTitle" });
    const twitterDescription = props.intl.formatMessage({ id: "calc.o.p.s.meta.twitterDescription" });
    const twitterImage = props.intl.formatMessage({ id: "calc.o.p.s.meta.twitterImage" });
    const twitterImageAlt = props.intl.formatMessage({ id: "calc.o.p.s.meta.twitterImageAlt" });

    // UI labels
    const title = props.intl.formatMessage({ id: "trading.online.voucher.scheme" });
    const headline = props.intl.formatMessage({ id: "application.form.helper" });
    const tagline = props.intl.formatMessage({ id: "fastest.application" });
    const quoteHeadline = props.intl.formatMessage({ id: "easy.quote" });
    const quoteTagline = props.intl.formatMessage({ id: "just.select.what.you.want" });

    const gridCardIndex = (
        <GridContainer justify='center'>
            <GridItem xs={12} sm={6} md={4}>
                <Card>
                    <CardBody>
                        <h3 className={classes.title}>
                            ABOUT YOUR BUSINESS
                        </h3>

                        <p>
                            Details such as name, contact into and if there's already an online presence.
                        </p>
                    </CardBody>
                    <CardFooter>
                        <Button className={classes.buttonAlignCenter} color="danger" component={ Link } to={paths.HELPER_T_O_V_S_ABOUT}>HELP</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <Card>
                    <CardBody>
                        <h3 className={classes.title}>
                            DESCRIBE YOUR BUSINESS
                        </h3>

                        <p>
                            Describe business activities, products or services. 
                        </p>
                    </CardBody>
                    <CardFooter>
                        <Button className={classes.buttonAlignCenter} color="danger" component={ Link } to={paths.HELPER_T_O_V_S_DESCRIBE}>HELP</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <Card>
                    <CardBody>
                        <h3 className={classes.title}>
                            PROJECT DESCRIPTION
                        </h3>
                        <p>
                            Describe the <b>business objectives</b> of the project. 
                        </p>
                    </CardBody>
                    <CardFooter>
                        <Button className={classes.buttonAlignCenter} color="danger" component={ Link } to={paths.HELPER_T_O_V_S_PROJECT}>HELP</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <Card>
                    <CardBody>
                        <h3 className={classes.title}>
                            PROJECT PLAN
                        </h3>
                        <p>
                            Your unique selling point, your competitors, target market and more. 
                        </p>
                    </CardBody>
                    <CardFooter>
                        <Button className={classes.buttonAlignCenter} color="danger" component={ Link } to={paths.HELPER_T_O_V_S_PLAN}>HELP</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <Card>
                    <CardBody>
                        <h3 className={classes.title}>
                            BUSINESS INVESTMENT
                        </h3>
                        <p>
                            Your own skills, money, assets, resources, etc. e.g. an existing website. 
                        </p>
                    </CardBody>
                    <CardFooter>
                        <Button className={classes.buttonAlignCenter} color="danger" component={ Link } to={paths.HELPER_T_O_V_S_INVEST}>HELP</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <Card>
                    <CardBody>
                        <h3 className={classes.title}>
                            PROJECTED OUTCOMES
                        </h3>
                        <p>
                            What you expect the business to gain from the project. 
                        </p>
                    </CardBody>
                    <CardFooter>
                        <Button className={classes.buttonAlignCenter} color="danger" component={ Link } to={paths.HELPER_T_O_V_S_OUTCOMES}>HELP</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <Card>
                    <CardBody>
                        <h3 className={classes.title}>
                            PROJECT ELEMENTS
                        </h3>
                        <p>
                            What specific work tasks do you plan to do. 
                        </p>
                    </CardBody>
                    <CardFooter>
                        <Button className={classes.buttonAlignCenter} color="danger" component={ Link } to={paths.HELPER_T_O_V_S_ELEMENTS}>HELP</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <Card>
                    <CardBody>
                        <h3 className={classes.title}>
                            PROJECT COSTS
                        </h3>
                        <p>
                            What are the costs of each specific work task. 
                        </p>
                    </CardBody>
                    <CardFooter>
                        <Button className={classes.buttonAlignCenter} color="danger" component={ Link } to={paths.HELPER_T_O_V_S_COSTS}>HELP</Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
                <Card>
                    <CardBody>
                        <h3 className={classes.title}>
                            GRANT HISTORY
                        </h3>
                        <p>
                            Your history of Irish State or EU funding. 
                        </p>
                    </CardBody>
                    <CardFooter>
                        <Button className={classes.buttonAlignCenter} color="danger" component={ Link } to={paths.HELPER_T_O_V_S_GRANT}>HELP</Button>
                    </CardFooter>
                </Card>
            </GridItem>
        </GridContainer>
    );

    return (
        <div>
            <CustomHelmet
                htmlLang={ogLocale}
                appName={appName}
                helmetTitle={ogTitle}
                metaDescription={ogDescription}
                ogType={ogType}
                ogSiteName={ogSiteName}
                ogTitle={ogTitle}
                ogDescription={ogDescription}
                ogLocale={ogLocale}
                ogLocaleAlt1={ogLocaleAlt1}
                ogLocaleAlt2={ogLocaleAlt2}
                ogImage={ogImage}
                ogImageType={ogImageType}
                ogImageWidth={ogImageWidth}
                ogImageHeight={ogImageHeight}
                ogImageAlt={ogImageAlt}
                twitterTitle={twitterTitle}
                twitterDescription={twitterDescription}
                twitterCardType={twitterCardType}
                twitterCreator={twitterCreator}
                twitterImage={twitterImage}
                twitterImageAlt={twitterImageAlt}
            />
            <CustomHeader
                brandName={appName}
                headerColor={headerColor}
            />
            <div className={classes.main}>
                <div className={classes.progress}>
                    {props.isLoading &&
                        <LinearProgress />
                    }
                </div>
                <div className={classes.container}>
                    {(props.errorMessage || props.successMessage) &&
                        <GridContainer justify='center'>
                            <GridItem xs={12} sm={12} md={7}>
                                {props.errorMessage &&
                                    <Message type="error" message={props.errorMessage} />
                                }
                                {props.successMessage &&
                                    <Message type="success" message={props.successMessage} />
                                }
                            </GridItem>
                        </GridContainer>
                    }
                    <GridContainer justify='center'>
                        <GridItem xs={12}>
                            <Card className={classes.cardProfile}>
                                <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                                    <h1 className={classNames(classes.cardTitle, classes.title)}>
                                        {title}
                                    </h1>
                                    <h2 className={classNames(classes.cardTitle, classes.title)}>
                                        {window.location.pathname.startsWith(paths.HELPER_T_O_V_S_QUOTE) ? quoteHeadline : headline}
                                    </h2>
                                    <p className={classNames(classes.cardTitle, classes.title)}>
                                        <i>{window.location.pathname.startsWith(paths.HELPER_T_O_V_S_QUOTE) ? quoteTagline : tagline}</i>
                                    </p>
                                </CardHeader>
                                <CardBody className={classes.cardBodyProfile}>
                                    <MuiThemeProvider theme={muiTheme}>
                                        {window.location.pathname === paths.HELPER_T_O_V_S && gridCardIndex}
                                        {window.location.pathname !== paths.HELPER_T_O_V_S && getStepContent(window.location.pathname, props)}
                                    </MuiThemeProvider>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        </div>
    );
}

ProfileWizardView.propTypes = {
    
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    completedSteps: PropTypes.array.isRequired,
    currentStep: PropTypes.number.isRequired,
    continuePath: PropTypes.object,
    setCurrentStep: PropTypes.func.isRequired,
    nextStep: PropTypes.func.isRequired,
    setIsLoading: PropTypes.func.isRequired,
    setSuccessMessage: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    resetMessages: PropTypes.func.isRequired
};

export default injectIntl(withStyles(tovsHelperStyle)(ProfileWizardView));